import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApplicableTableSettings, codesAesExportLicenseList } from '../../../../tableSettings';

import useFastStorage from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';

import ApplicationContext from '../../../../ApplicationContext';
import { Portal } from 'react-portal';
import useSystemSettings from '../../../../hooks/useSystemSettings';
import { Search } from '../../../../filtering';
import { CodeExportLicListItem } from '../../../../fms.data/models/CodeExportLicListItem';
import { JobNames } from '../../../../framework.core/JobNames';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import { FmsSecTask } from '../../../../fms.core/constants';
import GreenButton from '../../../../ui/GreenButton';
import ClearableSearch from '../../../../uiControls/ClearableSearch';
import TextBox from '../../../../ui/TextBox';
import EditableTable, { CellData, EditableTableHandle, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import { checkTabIsDirty, sortingListData } from '../../ReferenceFiles';
import { findSecurityTask } from '../../../../util';

import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import CloseButton from '../../../../ui/CloseButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
//  interface ILicenseInfo {
//    code?: string,
//    description?: string,
//    isNew?: boolean,
//  }

// let inlineElement:ILicenseInfo = {};

// function ActionRenderer({ data, row }:any) {
//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Cancel"
//         
//         onClick={() => data[row.index].isNew ? data[row.index].onDelete() : data[row.index].requestOperationCancel()}
//       >
//         <FontAwesomeIcon icon={faTimes} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       {!data[row.index].isNew && data[row.index].listSec?.grantDel &&
//         <>
//           <PrimaryInverseButton
//             disabled={data[row.index].editIndex !== row.index}
//             style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//             data-tooltip="Delete"
//             
//             onClick={() => data[row.index].onDelete()}
//           >
//             <FontAwesomeIcon icon={faTrashAlt} />
//           </PrimaryInverseButton>
//         </>
//       }
//     </div>
//   );
// }

function CodeRenderer({data, row, cell}:any) {
  // useEffect(() => {
  //   const focusElement = document.getElementById('ifms-aescode') as HTMLInputElement;
  //   if (focusElement) {
  //     focusElement.focus();
  //     focusElement.select();
  //   }
  // },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   []
  // );

    const changeLineItem = data[0].changeLineItem;
        return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-aescode-${row.index}`} maxLength={3} value={data[row.index].code} onChange={(e) => {
          changeLineItem(row.index, {code: e.target.value, isUpdate: true});
          }} />
      </div>
    );
}

function DescriptionRenderer({data, row, cell}:any) {
    const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-aesdescription-${row.index}`} maxLength={1000} value={data[row.index].description} onChange={(e) => {
          changeLineItem(row.index, {description: e.target.value, isUpdate: true});
          }} />
      </div>
    );
}

class EditableCodeExportInfoListItem extends CodeExportLicListItem {
  isNew: boolean = false;
  isDelete: boolean = false;
  isUpdate: boolean = false;
}

function formatElement(data: any) {
  const result = new EditableCodeExportInfoListItem();
  result.code = data.code;
  result.description = data.description;
  result.cid = data.cid;
  result.isNew = false;
  result.isDelete = false;

  return result;
}

function formatData(data:Array<any>) {
  return data.map(d => formatElement(d));
}

function LicenseInfos() {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
  }});
  useFunctionKeys({onSave: handleSaveAndClose});
  
  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const savedDataRef = useRef<Array<CodeExportLicListItem>>([]);
  const tableRef = useRef<EditableTableHandle>(null);
  const masterTableRef = useRef<EditableTableHandle>(null);
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState(Array<String>());
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, ] = useFastStorage(`ifms-referenceFiles-aes-licenseinfo-list`, []);
  //const [ei, setEi, , ediRef] = useFastStorage(`ifms-referenceFiles-aes-licenseinfo-editindex`, -1);
  const systemSettings = useSystemSettings();
  const tableHeight = 520;
  const listSec = findSecurityTask(appContext, FmsSecTask.CodeExportLic);
  const [focusFirstCell, setFocusFirstCell] = useState(true);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-aes-licenseinfo-orderby`,{
    orderBy: 'code',
    orderByAscending: true,
    general1: 'Code',
    pageSize: systemSettings.defaultPageSize,
  })
 // const addingToTheFirstLine = useRef(false);
  const oriData = useRef<CodeExportLicListItem[]>([]);

  const listItemType = 'CodeExportLicListItem';

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }

  function setData(d:Array<any>, callByFetchData: boolean = false) {
    setFocusFirstCell(callByFetchData);
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeExportLicListItem, oriData.current, d));
  }

  async function cancelOperation(){
    setHasChanges(false);
    removeData();
    return true;
  }

  function getIndexOfFirstInvalidCell(rowIndex: number){
    if(!data){
      return undefined;
    }

    if(!data[rowIndex].code){
      return 1;
    }
    if (allData) { //기존데이터 목록
      const newData = [...allData];
      if(newData.filter(x => x === data[rowIndex].code.toLowerCase()).length === 0) // 현재 목록에 없음
      {
        newData.splice(rowIndex, 1, data[rowIndex].code.toLowerCase());
        setAllData(newData);
        return undefined;
      }else{
        if(newData[rowIndex] === data[rowIndex].code.toLowerCase()) return undefined;
        else{
          showGlobalOkDialog(<p>'{data[rowIndex].code}' is a duplicate value.</p>);
          return 1;
        }
      }
    } 
    else {
      const newData = [data[rowIndex].code.toLowerCase()];
      setAllData(newData);
    }
    return undefined;
  }
  

  async function fetchData(api:any, search: Search) {
    setLoading(true);

    const searchModel = CodeExportLicListItem.calculateSearchParameters(search);
    const apiResult = await api.getListItems(JobNames.ExportLic,
      'CodeExportLicListItem',
      searchModel, 1, search.pageSize);
    // const apiResultforAll = await api.getListItems(JobNames.ExportLic,
    //   'CodeExportLicListItem',
    //   searchModel,
    //   1);

    oriData.current = formatData(apiResult && apiResult.entities ? apiResult.entities : []);
    setData(formatData(apiResult && apiResult.entities ? apiResult.entities : []), true);
    savedDataRef.current = apiResult && apiResult.entities ? apiResult.entities : [];

    // if(apiResultforAll && apiResultforAll.entities){
    //   setAllData(apiResultforAll.entities.map((a: CodeExportLicListItem) => a.code.toLowerCase()));
    // }

    setFocusFirstCell(false);
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (data.length === 0)
      reload();
    else {
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
    }
    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  async function reload(generalText:string = '') {
    setOrderBy({
      orderBy: 'code',
      orderByAscending: true,
      pageSize: systemSettings.defaultPageSize,
      generalText1: generalText,
    })

    await fetchData(appContext.api, orderBy);
  }

  function onHeaderClick(header: any) {
    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }
    }

    removeData();
    sortingListData(CodeExportLicListItem, data, setData, orderBy);
  }

  // async function requestOperationCancel() {
  //   const doCancel = await showGlobalYesNoDialog(<p>Are you sure you want to cancel Edit operation</p>);
  //   if (doCancel) {
  //     cancelOperation(false)
  //   } else {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80);
  //   }
  // }

  // async function onRowIndexChanged(rowIndex:number) {
  //   if (rowIndex < 0 && ediRef.current >= 0) {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80)
  //     return;
  //   }

  //   if (ediRef.current >= 0 && ediRef.current !== rowIndex) {
  //     await requestOperationCancel();
  //   }
  // }

  // function onRowSelect(rowIndex:number) {
  //   if (rowIndex >= 0 && rowIndex < dataRef.current.length && _.isEmpty(inlineElement) && (listSec?.grantEdit || listSec?.grantDel)) {
  //     setHasChanges(true);
  //     inlineElement = {...dataRef.current[rowIndex], isNew: false};
  //     setEi(rowIndex);
  //   }
  // }

  // function selectForNew() {
  //   inlineElement = {
  //     code: '', description: '', isNew: true,
  //   };
  //   data.unshift(inlineElement);
  //   setData(data);
  //   setEi(0);
  //   setHasChanges(true);
  // }

  // function cancelOperation(leaveNew:boolean=false) {
  //   setHasChanges(false);

  //   clearTableSelection();
  //   setEi(-1);

  //   if (!leaveNew && inlineElement.isNew) {
  //     dataRef.current.splice(0, 1);
  //     setData(dataRef.current);
  //   }

  //   inlineElement = {};
  // }

  // function addingLineToFirstLine(){
  //   addingToTheFirstLine.current = true;
  //   masterTableRef.current?.add();
  // }

  function addLineItem() {
    const newRow = new EditableCodeExportInfoListItem();
    newRow.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newRow
    };
  }


  // function addLineItem() {
  //   const newData = [...data];
  //   newData.push({description: '', code: '', isNew: true});
  //   //setHasChanges(true);
  //   setData(newData);
  //   return true;
  //  }

  function applyToLineItem(rowIndex: number, change: Partial<EditableCodeExportInfoListItem>|null) {
    if (!change || !data) {
      return;
    }
    const newData = [...data];
    const checkData = newData[rowIndex];
    if (!change.isNew && (change.code !== checkData.code || change.description !== checkData.description)) {
    _.merge(newData[rowIndex], {..._.omit(change, ['isNew']), hasBeenChanged: true});
    setData(newData);
    //setHasChanges(true);
    }
  }


  function deleteEntity(index:number):boolean {
    if(!data){
      return false;
    }

    const element = data[index];
    if(!element.isNew){
      let deleteRow = savedDataRef.current.find(x=>x.code === element.code)
      if(deleteRow){
        deleteRow.isDelete = true;
      }
    }
    data.splice(index, 1);
    setData(data);
    const tempData = data.map((a: CodeExportLicListItem) => a.code.toLowerCase());
    const newData = allData.splice(0,tempData.length,tempData);
    setAllData(newData);
    return true;
  }

  async function duplicateCell(checkData: any) {
    let duplicateFieldText = '';

    let isDuplicate = false;
    let insList = checkData.filter((x: any) => x.isNew === true);
    let chgList = checkData.filter((x: any) => x.hasBeenChanged === true && !x.isNew);
    let focusRow = -1;

    if (insList.length > 0 && data.length > 0) {
      for (let i = 0; i < insList.length; i++) {
        let count = 0;
        let tempRow = -1;
        for (let j = 0; j < data.length; j++) {
          if (insList[i].code.toUpperCase() === data[j].code.toUpperCase()) {
            if (count === 0) { tempRow = j; }
            count++;
            if (count > 1) {
              if (focusRow === -1) focusRow = tempRow;
              break;
            }
          }
        }
        if (count > 1) {
          duplicateFieldText += `'${insList[i].code}' is a duplicate value.\r\n`;
          isDuplicate = true;
        }
      }
    }

    if (chgList.length > 0 && data.length > 0) {
      for (let i = 0; i < chgList.length; i++) {
        let count = 0;
        let tempRow = -1;
        for (let j = 0; j < data.length; j++) {
          if (chgList[i].code.toUpperCase() === data[j].code.toUpperCase()) {
            if (!data[j].isNew && data[j].hasBeenChanged === true && tempRow === -1) { tempRow = j; }
            count++;
            if (count > 1) {
              if (focusRow === -1) focusRow = tempRow;
              break;
            }
          }
        }
        if (count > 1) {
          duplicateFieldText += `'${chgList[i].code}' is a duplicate value.\r\n`;
          isDuplicate = true;
        }
      }
    }

    if (!isDuplicate) {
      const apiResult = await appContext.api.checkDuplicatedKeys(JobNames.ExportLic, listItemType, insList, chgList);
      if (apiResult && apiResult.success && apiResult.message) {
        duplicateFieldText = `${apiResult.message}`;
        isDuplicate = true;
      } else if (!apiResult || !apiResult.success) {
        await showGlobalOkDialog('Could not check duplication.\r\nPlease try later.');
        return true;
      }
    }
    else
      await showGlobalOkDialog(`${duplicateFieldText}Please try after correcting duplication.`);

    return isDuplicate;
  }

  async function save() {
    // if (!inlineElement.isNew && !hasChanges) {
    //   cancelOperation();
    //   return;
    // }

    //<pt220818: portal
    // const apiResult = inlineElement.isNew
    //   ? await appContext.api.createCodesAesExportLicense(_.omit(inlineElement, ['isNew']))
    //   : await appContext.api.editCodesAesExportLicense({
    //     oldCode: data[ei].code,
    //     ..._.omit(inlineElement, ['isNew'])
    //   });

    // if (!apiResult || !apiResult.success) {
    //   return;
    // }

    // data[ei] = formatElement(apiResult.data);
    if (!data) {
      return;
    }

    let validData = data.filter((x:any) => x.code);
    
    let errMsg = '';
    const dataToSave = validData.filter((x: any, i: number) => x.isNew || x.hasBeenChanged === true);
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload(orderBy?.generalText1 || '');
      return;
    }
    setLoading(true);

    for (let i = 0; i < dataToDelete.length; ++i) {
      const s = dataToDelete[i];
      const apiResult: ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType, SQLType.Delete, _.omit(s, ['isDelete']));
      if (!apiResult || !apiResult.success)
        errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
    }

    if (dataToSave.length > 0) {
      const isDuplicate = await duplicateCell(dataToSave);
      if(isDuplicate){
        setLoading(false);
        return;
      }
      const cidData = dataToSave.map((a: CodeExportLicListItem) => a.cid?.toLowerCase()) as Array<String>;

      const secondSave = dataToSave.filter((x: CodeExportLicListItem) => cidData.includes(x.code.toLowerCase()));
      const firstSave = dataToSave.filter((x: CodeExportLicListItem) => !secondSave.includes(x));

      if (firstSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, firstSave);
        if (!apiResult || !apiResult.success) {
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);
        }
        else {
          firstSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.code === x.code);
            if (index >= 0) {
              data[index].cid = x.code;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              delete data[index].isNew;
            }
          })
        }
      }
      if (secondSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, secondSave);
        if (!apiResult || !apiResult.success) {
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);
        }
        else {
          secondSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.code === x.code);
            if (index >= 0) {
              data[index].cid = x.code;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              delete data[index].isNew;
            }
          })
        }
      }
    }

    if (errMsg) {
      await showGlobalOkDialog(<p>{errMsg}</p>);
      setLoading(false);
      return;
    }

    // setData(data);
    // savedDataRef.current = _.cloneDeep(data);
    // oriData.current = _.cloneDeep(data);
    
    // setLoading(false);
    // setHasChanges(false);
    reload(orderBy?.generalText1 || '');

    await showGlobalOkDialog(<p>The data has been saved</p>);

    // const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem('CodeExportLicListItem',
    //   inlineElement.isNew ? SQLType.Insert : SQLType.Update,
    //   _.omit(inlineElement, ['isNew']));
    // if(!apiResult.success) {
    //   await showGlobalOkDialog(<p>{apiResult.message}</p>);
    //   return;
    // }

    // // code is pkey
    // data[ei] = formatElement(inlineElement);
    // //pt220818>
    // cancelOperation(true);
  }


  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-aes-licenseinfo-list',
    ref: tableRef,
    selectable: true,
    tableName: 'aesLicenseInfoList',
    ...codesAesExportLicenseList,
    height: `${tableHeight}px`,
    //data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), editIndex: ei, onDelete: deleteEntity, onSave: save, onCancel: cancelOperation, setHasChanges, requestOperationCancel, listSec})),
    data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), changeLineItem: applyToLineItem})),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'code',  EditCell: CodeRenderer },
      { accessor: 'description', EditCell: DescriptionRenderer },
    //  { accessor: 'action', Cell: ActionRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'code')
        return { type: TableCellTypes.Text, value: data[rowIndex].code };
      else if (accessor === 'description')
       return { type: TableCellTypes.Text, value: data[rowIndex].description };
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
    },

    onHeaderClick,
    orderBy: [orderBy],
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };

  //const canSelectForNew = ei === -1;
  const canBeAdd = listSec?.grantAdd;

  return (
    <div style={{ marginTop: '40px'}}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>AES <FontAwesomeIcon icon={faAngleRight} />&nbsp;License Info</h1>
      </Portal> */}
      
      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element">
            <GreenButton size="regular" disabled={loading} onClick={save}>Save</GreenButton>
          </div>
          <div className="ifms-common-bar-element ifms-left-separator-light-gray">
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
          {/* <div className="ifms-common-bar-element">
            <BlackInverseButton name='list-screen-refresh' size="large" style={{marginTop: '-5px'}} disabled={loading} onClick={() => { reload(orderBy?.generalText1 || '') }} data-tooltip="Refresh" >
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </BlackInverseButton>
          </div> */}
        </div>
      </Portal>

      <div style={{ display: 'flex', width: '864px' }}>
        <div style={{width: '320px', fontSize: '11px', fontWeight: 'bold'}}>
          <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={async generalText1 => {await reload(generalText1 === null ? '' : generalText1); }} />
        </div>
        <div style={{ marginLeft: 'auto' }}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
         {// <SecondaryButton name='codes-licenseinfo-add-button' size="regular" disabled={!canBeAdd} onClick={() => { addingLineToFirstLine() }}><FontAwesomeIcon icon={faPlus} />&nbsp; Add Line</SecondaryButton> &nbsp; 
          }
          <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(orderBy?.generalText1 || '') }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>
      </div>
      {/* <SmartTable {...tableOptions} /> */}

      <div style={{ width: '864px' }}>
        <EditableTable
          initializeFocusedCell={focusFirstCell}
          ref={masterTableRef}
          tableOptions={tableOptions}
          deleteLine={deleteEntity}
          addLine={addLineItem}
          getIndexOfFirstInvalidCell={getIndexOfFirstInvalidCell}
        />
      </div>
    </div>
  );
}

export default LicenseInfos;
